import { Coverage, CoverageLevel, ScreenWithCoverages } from "../types";
import { ExtraCoverageAccessor } from "./extraCoverageAccessor";
import { getExtraCoverageGetters } from "./extraCoveragesDetails";

const getExtraCoveragesMap = (
  screen: ScreenWithCoverages
): Record<ExtraCoverageAccessor, Coverage> => ({
  [ExtraCoverageAccessor.GolfCartDamageAndLiabilityCoverage]: {
    accessor: ExtraCoverageAccessor.GolfCartDamageAndLiabilityCoverage,
    image: "/images/coverage-icons/golf-cart.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.GolfCartDamageAndLiabilityCoverage,
      screen
    ),
  },
  [ExtraCoverageAccessor.EnhancedCoverage]: {
    accessor: ExtraCoverageAccessor.EnhancedCoverage,
    image: "/images/coverage-icons/enhanced.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.EnhancedCoverage, screen),
  },
  [ExtraCoverageAccessor.TripCollisionCoverage]: {
    accessor: ExtraCoverageAccessor.TripCollisionCoverage,
    image: "/images/coverage-icons/trip-collision.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.TripCollisionCoverage,
      screen
    ),
  },
  [ExtraCoverageAccessor.EarthquakeCoverage]: {
    accessor: ExtraCoverageAccessor.EarthquakeCoverage,
    image: "/images/coverage-icons/earthquake.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.EarthquakeCoverage,
      screen
    ),
  },
  [ExtraCoverageAccessor.VacationRentalCoverage]: {
    accessor: ExtraCoverageAccessor.VacationRentalCoverage,
    image: "/images/coverage-icons/vacation-rental.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.VacationRentalCoverage,
      screen
    ),
  },
  [ExtraCoverageAccessor.WaterBackupCoverage]: {
    accessor: ExtraCoverageAccessor.WaterBackupCoverage,
    image: "/images/coverage-icons/water-backup.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.WaterBackupCoverage,
      screen
    ),
  },
  [ExtraCoverageAccessor.MineSubsidence]: {
    accessor: ExtraCoverageAccessor.MineSubsidence,
    image: "/images/coverage-icons/mine-subsidence.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.MineSubsidence, screen),
  },
  [ExtraCoverageAccessor.MineSubsidenceScheduled]: {
    accessor: ExtraCoverageAccessor.MineSubsidenceScheduled,
    image: "/images/coverage-icons/mine-subsidence.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.MineSubsidenceScheduled,
      screen
    ),
  },
  [ExtraCoverageAccessor.DebrisRemoval]: {
    accessor: ExtraCoverageAccessor.DebrisRemoval,
    image: "/images/coverage-icons/debris-removal.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.DebrisRemoval, screen),
  },
  [ExtraCoverageAccessor.LossAssessment]: {
    accessor: ExtraCoverageAccessor.LossAssessment,
    image: "/images/coverage-icons/loss-assessment-coverage.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.LossAssessment, screen),
  },
  [ExtraCoverageAccessor.IncidentalFarming]: {
    accessor: ExtraCoverageAccessor.IncidentalFarming,
    image: "/images/coverage-icons/incidental-farming.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.IncidentalFarming, screen),
  },
  [ExtraCoverageAccessor.LandlordPersonalInjury]: {
    accessor: ExtraCoverageAccessor.LandlordPersonalInjury,
    image: "/images/coverage-icons/landlord-personal-injury.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.LandlordPersonalInjury,
      screen
    ),
  },
  [ExtraCoverageAccessor.EquipmentBreakdown]: {
    accessor: ExtraCoverageAccessor.EquipmentBreakdown,
    image: "/images/coverage-icons/equipment-breakdown.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.EquipmentBreakdown,
      screen
    ),
  },
  [ExtraCoverageAccessor.SinkholeCoverage]: {
    accessor: ExtraCoverageAccessor.SinkholeCoverage,
    image: "/images/coverage-icons/sinkhole-loss.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.SinkholeCoverage, screen),
  },
  [ExtraCoverageAccessor.ValuableItemProtection]: {
    accessor: ExtraCoverageAccessor.ValuableItemProtection,
    image: "/images/coverage-icons/valuable-item-protection.webp",
    level: CoverageLevel.Policy,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.ValuableItemProtection,
      screen
    ),
  },
  [ExtraCoverageAccessor.ResidenceBurglary]: {
    accessor: ExtraCoverageAccessor.ResidenceBurglary,
    image: "/images/coverage-icons/residence-burglary.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.ResidenceBurglary, screen),
  },
  [ExtraCoverageAccessor.BuildersRisk]: {
    accessor: ExtraCoverageAccessor.BuildersRisk,
    image: "/images/coverage-icons/builders-risk.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(ExtraCoverageAccessor.BuildersRisk, screen),
  },
  [ExtraCoverageAccessor.SecondaryResidenceLiability]: {
    accessor: ExtraCoverageAccessor.SecondaryResidenceLiability,
    image: "/images/coverage-icons/secondary-residence-liability.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.SecondaryResidenceLiability,
      screen
    ),
  },
  [ExtraCoverageAccessor.VandalismOrMaliciousMischief]: {
    accessor: ExtraCoverageAccessor.VandalismOrMaliciousMischief,
    image: "/images/coverage-icons/vandalism-or-malicious-mischief.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.VandalismOrMaliciousMischief,
      screen
    ),
  },
  [ExtraCoverageAccessor.WindstormOrHailExclusion]: {
    accessor: ExtraCoverageAccessor.WindstormOrHailExclusion,
    image: "/images/coverage-icons/windstorm-or-hail-exclusion.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.WindstormOrHailExclusion,
      screen
    ),
  },
  [ExtraCoverageAccessor.FortifiedRoofUpgrade]: {
    accessor: ExtraCoverageAccessor.FortifiedRoofUpgrade,
    image: "/images/coverage-icons/fortified-roof-upgrade.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.FortifiedRoofUpgrade,
      screen
    ),
  },
  [ExtraCoverageAccessor.RoofPaymentSchedule]: {
    accessor: ExtraCoverageAccessor.RoofPaymentSchedule,
    image: "/images/coverage-icons/roof-payment-schedule.webp",
    level: CoverageLevel.Unit,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.RoofPaymentSchedule,
      screen
    ),
  },
  [ExtraCoverageAccessor.IdentityFraudExpense]: {
    accessor: ExtraCoverageAccessor.IdentityFraudExpense,
    image: "/images/coverage-icons/identity-fraud.webp",
    level: CoverageLevel.Policy,
    ...getExtraCoverageGetters(
      ExtraCoverageAccessor.IdentityFraudExpense,
      screen
    ),
  },
});

export { getExtraCoveragesMap };
